export default __webpack_public_path__ + "static/video-placeholder-3d52c1a55a7ce0e00dd4990e3cfeadee.webp";